<template>
  <a-dropdown :trigger="['click']" placement="bottomCenter">
    <div :class="$style.dropdown">
      <a-avatar :src="getUserAvatar" shape="square" icon="user" :class="$style.avatar" />
    </div>
    <a-menu slot="overlay" :class="$style.menuItem">
      <a-menu-item>
        <strong>{{ $t('topBar.profileMenu.hello') }}, {{ getUsername }}</strong>
      </a-menu-item>
      <a-menu-divider />
      <a-menu-item>
        <!-- <div>
          <strong class="mr-1">{{ $t('topBar.profileMenu.email') }}:</strong>
          {{user.user.email}}
        </div>-->
        <!-- <div>
          <strong class="mr-1">{{ $t('topBar.profileMenu.phone') }}:</strong> -
        </div>-->
      </a-menu-item>
      <!-- <a-menu-divider />
      <a-menu-item>
        <router-link :to="{name:'account'}">Account Invoices & Payments</router-link>
      </a-menu-item>
      <a-menu-divider />-->
      <a-menu-item>
        <router-link :to="{ name: 'updateUserInfo' }">
          <i :class="$style.menuIcon" class="fe fe-user"></i>
          {{ $t('topBar.profileMenu.editProfile') }}
        </router-link>
      </a-menu-item>
      <a-menu-item v-if="isAdmin">
        <router-link :to="{ name: 'adminSettings2' }">
          <i :class="$style.menuIcon" class="fe fe-settings"></i>
          {{ $t('topBar.profileMenu.settings') }}
        </router-link>
      </a-menu-item>
      <a-menu-item>
        <a href="javascript: void(0);" @click="logout">
          <i :class="$style.menuIcon" class="fe fe-log-out"></i>
          {{ $t('topBar.profileMenu.logout') }}
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapState } from 'vuex';
import { includes } from 'lodash';

export default {
  computed: {
    ...mapState({
      user: 'user',
    }),
    getUsername() {
      return `${this.user.user.firstname} ${this.user.user.lastname}`;
    },
    getUserAvatar() {
      return this.user.user.photo_url;
    },
    isAdmin() {
      return includes(this.user.user.role, 'admin');
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push({ name: 'signIn' });
    },
  },
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
